import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

extend('full_name', {
  ...required,
  validate: value => {
    const pattern = /\b\w+\b(?:\s+\b\w+\b)+/

    return pattern.test(value)
  },
  message: 'This field must be a full name'
})

extend('postal_code', {
  validate: value => {
    // US ZIP code pattern (5 digits or 5+4 format)
    const pattern = /^\d{5}(-\d{4})?$/

    return pattern.test(value)
  },
  message: 'Please enter a valid postal code (e.g., 12345 or 12345-6789)'
})
